export default __webpack_public_path__ + "static/media/innovative_lyallpur.45071582.jpg";